import { render, staticRenderFns } from "./loader-icon.vue?vue&type=template&id=6fb0efba&scoped=true"
import script from "./loader-icon.vue?vue&type=script&lang=js"
export * from "./loader-icon.vue?vue&type=script&lang=js"
import style0 from "./loader-icon.vue?vue&type=style&index=0&id=6fb0efba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb0efba",
  null
  
)

export default component.exports